<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16.81" height="16.81" viewBox="0 0 16.81 16.81">
		<g id="Group_44928" data-name="Group 44928" transform="translate(-535.434 -598.121)">
			<g id="Group_44927" data-name="Group 44927" transform="translate(536.184 599.834)">
				<path
					id="Path_30615"
					data-name="Path 30615"
					d="M0,0V3.051A.654.654,0,0,0,.654,3.7H6.514"
					transform="translate(7.166 13.694) rotate(180)"
					fill="none"
					stroke="#6b7786"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_30616"
					data-name="Path 30616"
					d="M8.88,1.446H2.9A2.152,2.152,0,0,0,.75,3.6V13.641A2.152,2.152,0,0,0,2.9,15.793H12.945A2.152,2.152,0,0,0,15.1,13.641V7.663"
					transform="translate(-0.75 -1.446)"
					fill="none"
					stroke="#6b7786"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
			</g>
			<path
				id="Path_30617"
				data-name="Path 30617"
				d="M6,0,0,6M0,6H2.332M0,6V3.665"
				transform="translate(545.186 599.182)"
				fill="none"
				stroke="#6b7786"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.5"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MinimizeVideoSvg',
};
</script>

<style scoped lang="scss"></style>
